import { useState } from 'react';

const ChangePasswordView = () => {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
  };

  return (
    <section className="flex flex-col gap-6">
      <header>
        <p className="text-xs font-bold uppercase tracking-widest text-text-subtle mb-1 font-body">Cuenta</p>
        <h2 className="text-2xl font-bold text-text-default m-0 font-display">Cambio de contraseña</h2>
      </header>
      <form onSubmit={handleSubmit} className="flex flex-col gap-4 max-w-sm">
        <label htmlFor="current-password" className="flex flex-col gap-1.5 text-sm font-semibold text-text-muted">
          Contraseña actual
          <input
            id="current-password"
            name="currentPassword"
            type="password"
            autoComplete="current-password"
            required
            value={currentPassword}
            onChange={(e) => setCurrentPassword(e.target.value)}
            className="h-10 px-3 border border-border-default rounded-lg text-sm font-normal text-text-default focus:outline-none focus:ring-2 focus:ring-border-focus focus:border-transparent"
          />
        </label>
        <label htmlFor="new-password" className="flex flex-col gap-1.5 text-sm font-semibold text-text-muted">
          Nueva contraseña
          <input
            id="new-password"
            name="newPassword"
            type="password"
            autoComplete="new-password"
            required
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            className="h-10 px-3 border border-border-default rounded-lg text-sm font-normal text-text-default focus:outline-none focus:ring-2 focus:ring-border-focus focus:border-transparent"
          />
        </label>
        <button
          type="submit"
          className="h-10 bg-action-brand-bg hover:bg-action-brand-hover text-text-inverse font-bold rounded-lg cursor-pointer transition-colors"
        >
          Actualizar
        </button>
      </form>
    </section>
  );
};

export default ChangePasswordView;
